import styled from 'styled-components';

import { mediaSmallOrTiny } from '@xing-com/layout-tokens';
import { space3XL, space5XL, spaceM, spaceXXL } from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

const NotFoundContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: ${space5XL} 0;
`;

const NotFoundCopy = styled(BodyCopy)`
  margin-top: calc(${spaceXXL} + ${spaceM});

  @media ${mediaSmallOrTiny} {
    padding: 0 ${space3XL};
  }
`;

export const Styled = { NotFoundContainer, NotFoundCopy };
